export default {
  sm: `
  우리 기술로 보호하는<br>우리의 데이터
  `,
};
